import { formatNumber, lengthOf } from '../../utils/recipeLimits'

import './style.css'

// Shown from this share of the limit onward, so the count appears before it's too late
const SHOW_COUNT_FROM = 0.8

/**
 * Under a form field: what to fix (when something is wrong) and, for fields with a
 * length limit, a character count once the text gets close to it. The count turns red
 * when the text is over.
 */
const FieldFeedback = ({ error, value, max, label }) => {
  const length = max ? lengthOf(value) : 0
  const showCount = max && length >= max * SHOW_COUNT_FROM
  const message = error?.message
  if (!message && !showCount) return null

  return (
    <div className="fieldFeedback">
      {message ? (
        <p className="formFieldError" role="alert">
          {message}
        </p>
      ) : (
        <span />
      )}
      {showCount ? (
        <span
          className={`fieldCount ${length > max ? 'fieldCountOver' : ''}`}
          aria-label={`${label ? `${label}: ` : ''}${length} of ${max} characters`}
        >
          {formatNumber(length)} / {formatNumber(max)}
        </span>
      ) : null}
    </div>
  )
}

// A short list of problems that aren't next to one field (or are on another page)
export const FormProblems = ({ problems = [] }) =>
  problems.length ? (
    <div className="formProblems" role="alert">
      {problems.length === 1 ? (
        <p>{problems[0]}</p>
      ) : (
        <>
          <p>Please fix these and try again:</p>
          <ul>
            {problems.map((problem) => (
              <li key={problem}>{problem}</li>
            ))}
          </ul>
        </>
      )}
    </div>
  ) : null

export default FieldFeedback
